define('gigaset_shoppingcodes/components/form',[
	"jquery",
	"cartware/components/_base",
	"cleave"
], function(
	$,
	Component,
	Cleave
) {
	return Component.create({
		$init: function(){
			if ($('.input-code').length) {
				var cleave = new Cleave('.input-code', {
					delimiter: '-',
					blocks: [4, 4, 4, 4],
					uppercase: true
				});
			}
		}
	});
});
